import React from "react";
import { formatCurrency } from "utils";
import { Typography } from "@mui/material";
import { calculateTotal } from "modules/equipment";
import { useFormContext, useWatch } from "react-hook-form";
import { ListingForm } from "components/shared/TableListing/types";
import { QuoteChargeListingEntity, QuoteChargeType } from "../../../../types";

export const EquipmentChargeGrandTotalCell = () => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();
  const bodyFields = useWatch({ control, name: "bodyFields" });

  const value = bodyFields.reduce<number>((total, { type, charge, equipment }) => {
    const renderCellContentByType: Record<QuoteChargeType, () => number> = {
      [QuoteChargeType.Invoice]: () => calculateTotal(charge!),
      [QuoteChargeType.Equipment]: () => {
        const equipmentTotal = calculateTotal(equipment?.price!);

        const attachmentsTotal = (equipment?.attachments ?? []).reduce(
          (total, attachment) => (total += calculateTotal(attachment.price)),
          0
        );

        return equipmentTotal + attachmentsTotal;
      },
    };

    total += renderCellContentByType[type]();

    return total;
  }, 0);

  return <Typography>{formatCurrency(value, true)}</Typography>;
};
